var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.mostrarFooterPersonalizado)?_c('footer-default'):_c('v-layout',[_c('v-footer',{staticClass:"pa-1 px-0",attrs:{"app":"","absolute":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.autoatendimento.footerHtml)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }